import React, { useState, useRef } from 'react';
import { MDBMask, MDBView, MDBCard, MDBIcon, MDBAnimation, MDBCollapse } from 'mdbreact';
import MovieDetails from './MovieDetails';

const Movie = ({searchResults, imageURL, IMDbRating, title, format, runtime, IMDbURL, year, director, cast, sinopse, trailer}) => { 

  const [collapseID, setCollapseID] = useState("");

  const childRef = useRef();

  const openIMDB = () => {
    window.open(IMDbURL, '_blank');
  };

  const toggleSinopseCollapse = () => {
    collapseID === '' ? setCollapseID('movieSinopse') : setCollapseID('')
  };

 
     return (
       <div className={`${searchResults.length === 1 ? "col-sm-4" : "col-sm-12 col-md-3"} mb-3`}>
          <MDBAnimation type="fadeInLeft" className='h-100'/* reveal delay={`${id * 0.15}s`}*/ >
              <MDBCard className="mb-4 h-100">
                    <div onClick={() => childRef.current.toggleModalRef()}>
                    <MDBView hover >
                        <img className="movie__img" src={imageURL} alt={title}/>
                        <MDBMask className="flex-center" overlay="orange-light" style={{borderRadius: '16px 16px 0 0', cursor: 'pointer'}}>
                         <p className="movie__img-title white-text deep-orange p-4 w-100 text-center z-depth-1">click for details</p>
                        </MDBMask>
                    </MDBView> 
                    </div>
                    <div className="d-flex h-100 justify-content-between flex-column p-3 text-center">
                      <h4 className="deep-orange-text font-weight-bold movie__title mb-0">{title}</h4>
                      <h6 className="brown-text mb-3">{director}</h6>
                      <h6 className="grey-text">{format}</h6>
                        <button onClick={openIMDB} className="btn btn-block deep-orange white-text movie-details-btn">IMDB 
                          <MDBIcon icon="external-link-alt" className="ml-3" size="lg"/>
                        </button>
                        <button className="btn btn-block yellow darken-3 white-text my-2 movie-details-btn" onClick={toggleSinopseCollapse}>Sinopse
                          <MDBIcon far icon="keyboard" className="ml-3" size="lg"/>
                        </button>
                        <MDBCollapse id="movieSinopse" isOpen={collapseID}>
                          <p className="text-monospace mt-4">{sinopse}</p>
                        </MDBCollapse>
                    </div>
                </MDBCard>
          </MDBAnimation>
          <MovieDetails imageURL={imageURL} IMDbRating={IMDbRating} title={title} runtime={runtime} year={year} director={director} cast={cast} sinopse={sinopse} trailer={trailer} ref={childRef}/>
       </div>
        
     )
   }

export default Movie;
